module.exports = __webpack_public_path__ + "media/images/cbs/logo-home-edd86f1c779f5622ea10060025cbb9e3.svg";